import React from "react";
import { ResourceEnum } from "src/constants/constants.ts";
import type { ModuleOptions } from "src/system/module.types.ts";
import type { BankTransactionResource } from "@exonn/js-sdk";

export const module: ModuleOptions<BankTransactionResource> = {
  resource: ResourceEnum.BankTransaction,
  bigIcon: <i className="icon-20-sales" />,
  smallIcon: <i className="icon-15-sales" />,
  list: {
    // hideEditAction: () => true,
    hideDeleteAction: () => true,
  },
  tabs: {
    edit: {
      getTitle: (resource) => resource.remote_bank_code,
    },
  },
  // disableEdit: true,
  disableCreate: true,
  disableDelete: true,
};
